(()=>{
 const scope='quick-buy-modal [data-snrs-quick-shop]';
 function controls(root){return [...root.querySelectorAll('variant-picker [data-snrs-size-position]')]}
 function update(root,variant){
  const form=root.querySelector('product-form form'),button=form?.querySelector('button[type="submit"]');
  if(!form||!button)return;
  const chosen=controls(root).every(group=>group.querySelector('input:checked'));
  const ready=chosen&&variant?.id;
  root.dataset.ready=ready?'true':'false';
  button.disabled=!ready||!variant.available;
  button.textContent=!chosen?root.dataset.selectLabel:!variant?.id?root.dataset.unavailableLabel:!variant.available?root.dataset.soldLabel:root.dataset.addLabel;
 }
 document.addEventListener('variant:change',event=>{
  const root=event.target.closest(scope);
  if(root)update(root,event.detail?.variant);
 });
 document.addEventListener('change',event=>{
  if(!event.target.matches('input[data-option-position]'))return;
  const root=event.target.closest('quick-buy-modal')?.querySelector('[data-snrs-quick-shop]');
  if(root){root.dataset.ready='false';const button=root.querySelector('product-form button[type="submit"]');if(button)button.disabled=true}
 },true);
 document.addEventListener('submit',event=>{
  const root=event.target.closest(scope);
  if(!root||!controls(root).length)return;
  if(root.dataset.ready!=='true'||controls(root).some(group=>!group.querySelector('input:checked'))){
   event.preventDefault();event.stopImmediatePropagation();
   controls(root).find(group=>!group.querySelector('input:checked'))?.querySelector('input')?.focus();
  }
 },true);
 const observer=new MutationObserver(records=>{
  for(const record of records)for(const node of record.addedNodes){
   if(node.nodeType!==1)continue;
   const root=node.matches?.('[data-snrs-quick-shop]')?node:node.querySelector?.('[data-snrs-quick-shop]');
   if(root&&root.closest('quick-buy-modal')&&!root.dataset.ready){
    controls(root).forEach(group=>group.querySelectorAll('input[data-option-position]').forEach(input=>{input.checked=false}));
    let variant;try{variant=JSON.parse(root.querySelector('script[data-variant]')?.textContent||'null')}catch{}
    update(root,variant);
   }
  }
 });
 observer.observe(document.documentElement,{childList:true,subtree:true});
})();
